import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AbstractControl, FormBuilder, ReactiveFormsModule, ValidationErrors } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

// The API refuses a blank reason and one longer than this (LockTradingCommandHandler.REASON_MAX_LENGTH).
export const REASON_MAX_LENGTH = 500;

// Without a bot name the whole broker account is being locked.
export type TradingLockDialogData = {
    brokerAccountName: string;
    botName?: string;
};

function notBlank(control: AbstractControl<string>): ValidationErrors | null {
    return control.value.trim().length > 0 ? null : { required: true };
}

// Measured on the reason as it is sent, without surrounding spaces, which is what the API measures.
function notTooLong(control: AbstractControl<string>): ValidationErrors | null {
    return control.value.trim().length <= REASON_MAX_LENGTH ? null : { maxlength: true };
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "app-trading-lock-dialog",
    imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule],
    providers: [{ provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }],
    templateUrl: "./trading-lock-dialog.component.html",
})
export class TradingLockDialogComponent {
    readonly data = inject<TradingLockDialogData>(MAT_DIALOG_DATA);
    private readonly dialogRef = inject<MatDialogRef<TradingLockDialogComponent, string>>(MatDialogRef);
    private readonly fb = inject(FormBuilder);

    readonly reasonMaxLength = REASON_MAX_LENGTH;
    readonly reason = this.fb.nonNullable.control("", [notBlank, notTooLong]);

    confirm(): void {
        if (this.reason.invalid) {
            return;
        }
        this.dialogRef.close(this.reason.value.trim());
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
